import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import type { RespondedType, ResponseError } from '@/models/response';
import ROUTES from '@/routes';
import { useMessageStore } from '@/stores/message';
import { addToast } from '@/stores/toast';
import { fetcher } from '@/utils/fetcher';
import { queryClient } from '@/utils/query-client';
import { useCommDispatcher, useIntercomDispatcher } from '../comm/use-comm';
import { friendsQueryOptions } from '../contacts/use-friends';
import useUserPlatform from '../use-user-platform';
import { blacklistQueryOptions } from './use-blacklist';

export default function useAddBlackList() {
  const navigate = useNavigate();
  const { isDesktop } = useUserPlatform();
  const { resetKey } = useMessageStore();
  const { dispatch } = useCommDispatcher();
  const { dispatch: interDispatch } = useIntercomDispatcher();
  return useMutation<RespondedType, ResponseError, number>({
    mutationKey: ['/AddBlackList'],
    mutationFn: (params) => fetcher('/AddBlackList', { UserID: params }, { validResponseCodes: [0] }),
    onSuccess: (_, userId) => {
      Promise.allSettled([
        queryClient.invalidateQueries(friendsQueryOptions),
        queryClient.invalidateQueries(blacklistQueryOptions),
      ]);

      dispatch({
        event: 'leave-session',
        data: { type: 'user', id: userId },
      });
      interDispatch({
        event: 'leave-session',
        data: { type: 'user', id: userId },
      });

      navigate(ROUTES.MESSAGES.$path(), { replace: true });
      if (isDesktop) resetKey();
    },
    onSettled: (data, error) => {
      addToast({
        type: data ? 'success' : 'error',
        message: data?.Msg ?? error?.message,
      });
    },
  });
}
